import { twMerge } from "tailwind-merge";
import { SpinnerLegacy } from "../../../components";
import { DiscoveryListSupplierCard } from "../../discovery/v2/DiscoveryListSupplierCard";
import { useDiscoverySuppliersByIdsList } from "../../../hooks/api/v2/discovery/useDiscoverySupplierByIdsList";
import { ORDER_BUYER } from "../../../constants/routes";
import { useNavigateToChild } from "../../../hooks/useParentNavigation";

export const SpotlightSupplierList = ({ ids }: { ids: number[] }) => {
  const navigateToChild = useNavigateToChild();

  const supplierListQuery = useDiscoverySuppliersByIdsList({
    query: [
      {
        type: "id",
        modifier: "IN",
        value: ids,
      },
    ],
    orderBy: "random",
  });

  const supplierList =
    supplierListQuery.data?.pages.flatMap((page) => page) ?? [];

  const isLoading = supplierListQuery.isLoading;

  return (
    <div className={"px-4 pb-4"}>
      {isLoading ? (
        <SpinnerLegacy />
      ) : (
        <>
          <div
            className={twMerge(
              "mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3",
            )}
          >
            {supplierList.map((supplier) => (
              <DiscoveryListSupplierCard
                key={supplier.id}
                supplier={supplier}
                onClick={() =>
                  navigateToChild(
                    ORDER_BUYER.href({ supplierIdOrUrlId: supplier.urlId }),
                  )
                }
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};
